// @ts-expect-error - TS7016 - Could not find a declaration file for module 'nearley'. '/home/runner/work/flow-to-typescript-codemod/flow-to-typescript-codemod/webflow/node_modules/nearley/lib/nearley.js' implicitly has an 'any' type.
import {Parser, Grammar} from 'nearley';
import * as w from '@packages/systems/wfdl';
import grammar from './grammars/wfdl-type';

const parserGrammar = Grammar.fromCompiled(grammar);

/**
 * Parse WFDL type syntax into a WFDL type.
 */
export const parseType = (text: string): w.Type => {
  const parser = new Parser(parserGrammar);
  parser.feed(text);

  if (parser.results.length > 0) {
    return parser.results[0];
  }

  throw new Error('Unexpected end of input');
};
